import React from 'react';

const PageHero = ({ eyebrow, title, description, image = '/images/HomeSlider_10.jpg', compact = false }) => (
  <header className={`site-page-hero${compact ? ' site-page-hero--compact' : ''}`}>
    <img className="site-page-hero__image" src={image} alt="" aria-hidden="true" />
    <div className="site-page-hero__shade" />
    <div className="site-container site-page-hero__content">
      {eyebrow && <p className="site-eyebrow site-eyebrow--light">{eyebrow}</p>}
      <h1>{title}</h1>
      {description && <p>{description}</p>}
    </div>
  </header>
);

export default PageHero;
